import { BrowserCanvasContext } from '@c2s-npm/plumlib';

export const {
  baseElementType,
  interruptibleRender,
  elementToUrl,
  renderToPNGUrl,
  getDrawProductSteps,
  renderProductToPNGUrl,
  loadImage,
  colorizeImage,
  resizeImage,
} = BrowserCanvasContext;
